module.exports = __webpack_public_path__ + "assets/img/logo.fb3f6655.svg";